import { NgModule } from '@angular/core';
import { ColorDirective } from './directives/color.directive';
import { RawColorDirective } from './directives/raw-color.directive';

@NgModule({
  declarations: [ColorDirective, RawColorDirective],
  exports: [ColorDirective, RawColorDirective]
})
export class UiHelperModule {}
//TODO: RENAME TO COMMON
